import React, { Component } from "react";
import { connect } from "react-redux";
import RaisedButton from "material-ui/RaisedButton";
import { TextField } from "redux-form-material-ui";

import { getStringOrEmpty } from "../../utils";
import { updateLatLng } from "./actions";

import "../common.css";
import "./Accomodation.css";

const defaultLng = 6.65369;
const defaultLat = 46.1479;

const mapOptions = google => ({
  panControl: false,
  mapTypeControl: false,
  gestureHandling: "cooperative",
  streetViewControl: false,
  mapTypeId: google.maps.MapTypeId.TERRAIN,
  maxZoom: 17,
  styles: [
    {
      stylers: [{ hue: "#44ccff" }, { saturation: -75 }, { lightness: 20 }]
    }
  ]
});

const loadGmaps = key => {
  return new Promise(resolve => {
    if (!window.google || !window.google.maps) {
      document.head.appendChild(
        Object.assign(document.createElement("script"), {
          src: `https://maps.googleapis.com/maps/api/js?v=3&key=${key}&libraries=places`,
          onload: resolve
        })
      );
    } else {
      resolve();
    }
  });
};

class AccomodationGeolocation extends Component {
  state = {
    googleReady: false,
    search: ""
  };

  marker = null;
  geocoder = null;

  componentDidMount() {
    loadGmaps("AIzaSyBmN0YGh-O3nXsqkDhPD5v0QX6DUuNRt14").then(this.initMap);
  }

  addDragEndListener = marker => {
    marker.addListener("dragend", e => {
      this.props.updateLatLng(
        this.props.merchantCode,
        e.latLng.lat(),
        e.latLng.lng()
      );
    });
  };

  initMap = () => {
    const google = window.google;
    this.geocoder = new google.maps.Geocoder();
    this.map = new google.maps.Map(this.mapNode, mapOptions(google));

    const lat =
      this.props.lat && !isNaN(parseFloat(this.props.lat))
        ? this.props.lat
        : defaultLat;
    const lng =
      this.props.lng && !isNaN(parseFloat(this.props.lng))
        ? this.props.lng
        : defaultLng;

    const latLng = new google.maps.LatLng(lat, lng);
    this.marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      draggable: true
    });

    const bounds = new google.maps.LatLngBounds();
    bounds.extend(latLng);
    this.map.fitBounds(bounds);

    const { address, cp, city } = this.props;
    google.maps.event.addListenerOnce(this.map, "idle", () => {
      this.setState({
        googleReady: true,
        search:
          !this.props.lat || !this.props.lng
            ? `${getStringOrEmpty(address)} ${getStringOrEmpty(
                cp
              )} ${getStringOrEmpty(city)}`
            : ""
      });
    });

    this.addDragEndListener(this.marker);

    google.maps.event.addListener(this.map, "click", e => {
      this.marker.setMap(null);
      this.marker = null;
      this.marker = new google.maps.Marker({
        position: e.latLng,
        map: this.map,
        draggable: true
      });
      this.addDragEndListener(this.marker);
      this.props.updateLatLng(
        this.props.merchantCode,
        e.latLng.lat(),
        e.latLng.lng()
      );
    });
  };

  searchChanged = (e, value) => {
    this.setState({ search: value });
  };

  geocode = e => {
    e.preventDefault();
    const { search } = this.state;
    this.geocoder.geocode({ address: search }, (results, status) => {
      if (status === "OK") {
        this.map.setCenter(results[0].geometry.location);
      } else {
        console.log(status);
      }
    });
  };

  renderSearchBar = () => {
    return (
      <div className="geocode-search-bar">
        <form className="geocode-search-form" onSubmit={this.geocode}>
          <TextField
            className="geocode-input-search"
            name="search"
            hintText="Que recherchez-vous ?"
            floatingLabelText="Votre recherche"
            value={this.state.search}
            ref="search"
            onChange={this.searchChanged}
            style={{ width: "70%" }}
          />
          <RaisedButton
            className="geocode-search-btn"
            label="Recherche"
            type="submit"
            secondary
          />
        </form>
      </div>
    );
  };

  renderGoogleMap = () => {
    return (
      <div ref={map => (this.mapNode = map)} className="esf-map-container" />
    );
  };

  render() {
    return (
      <div className="card-container">
        <div className="card">
          <div className="title">Coordonnées de l'hébergement</div>
          <div className="inner">
            {this.renderSearchBar()}
            {this.renderGoogleMap()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  merchantCode: state.merchant.detail.code,
  lat: state.accomodation.lat,
  lng: state.accomodation.lng,
  address: state.accomodation.address1,
  city: state.accomodation.city,
  cp: state.accomodation.cp
});

const mapDispatchToProps = dispatch => ({
  updateLatLng: (merchantCode, lat, lng) => {
    dispatch(updateLatLng(merchantCode, lat, lng));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccomodationGeolocation);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/AccomodationGeolocation.js